import { Form, Select } from 'antd';
import React from 'react';
import { UrgenciaProps } from './props';
import TextFilter from '../TextFilter';

const SelectUrgencia: React.FC<UrgenciaProps> = ({ setUrgencia }) => {
  const { Option } = Select;

  const onChange = (values: any) => {
    setUrgencia(values);
    localStorage.setItem(`urgencia${window.location.pathname}`, values);
  };

  return (
    <>
      <Form.Item label={<TextFilter>Classificação de urgência</TextFilter>} name="urgencia">
        <Select onChange={onChange} style={{ width: '100%' }}>
          <Option value="URGENTE">Urgente</Option>
          <Option value="ALTA">Alta</Option>
          <Option value="MEDIA">Média</Option>
          <Option value="BAIXA">Baixa</Option>
        </Select>
      </Form.Item>
    </>
  );
};

export default SelectUrgencia;
